import React from 'react';
import EvaluationStatesCircle from '../../States/EvaluationStatesCircle';
import LinkUI from '../../Buttons/LinkUI';
import { Indicator } from '../../../interfaces/ODSPriorityGroups';
import { GROUPS, INDICATOR_TYPE_STRUCTURAL } from '../../../utils/const';
import EvaluationLaws from '../../States/EvaluationLaws';
import { onClickLinkUI } from './utils';

// Tipos de props
interface ODSSelected {
    id: number;
    name: string;
}

interface MobileTableRelatedIndicatorsProps {
    indicadores: Indicator[];
    period: string;
    odsSelected: ODSSelected;
    buildIndicatorUrl: (indicator: Indicator, odsSelected: {
        id: number;
        name: string;
    }, module: string,
        period: string,
        isGroups: string
    ) => string;
    module: string;
    page: number;
}

function MobileTableRelatedIndicators({
    indicadores,
    period,
    odsSelected,
    buildIndicatorUrl,
    module,
    page,
}: MobileTableRelatedIndicatorsProps) {
    return (
        <section className="rounded-sm border border-system-light-40">
            <div className="bg-primary-200 h-6 rounded-t-sm" />

            {indicadores.map((related, idx) => (
                <div
                    key={idx}
                    className="px-3 py-4 border-t-[0.5px] border-system-light-40 flex flex-col gap-4"
                >
                    <div>
                        <h5 className="text-lsmall text-system-light-40">INDICADORES</h5>
                        {related.tipoIndicador.titulo === INDICATOR_TYPE_STRUCTURAL ? (
                            <span className="text-bmedium text-system-light-50">
                                {related.titulo}
                            </span>
                        ) : (
                            <LinkUI
                                href={buildIndicatorUrl(related, odsSelected, module, period, GROUPS)}
                                onClick={() => onClickLinkUI(related, odsSelected, module, period, GROUPS, page)}
                                title={related.titulo}
                            >
                                {related.titulo}
                            </LinkUI>
                        )}
                    </div>

                    <div >
                        <p className="text-lsmall text-system-light-40">DERECHO:
                            <span className="text-bmedium text-system-light-50 ml-2">{related.derecho.titulo}</span>
                        </p>
                    </div>

                    <div>
                        <p className="text-lsmall text-system-light-40">DIMENSIÓN:
                            <span className="text-bmedium text-system-light-50 ml-2">{related.dimension.titulo}</span>
                        </p>

                    </div>

                    {module === GROUPS &&
                        <div>
                            <p className="text-lsmall text-system-light-40">SUBDIMENSIÓN:
                                <span className="text-bmedium text-system-light-50 ml-2">{related.subdimension.titulo}</span>
                            </p>
                        </div>
                    }

                    <div className="flex gap-2 items-center">
                        <p className="text-lsmall text-system-light-40">EVALUACIÓN</p>
                        {
                            related.tipoIndicador.titulo !== INDICATOR_TYPE_STRUCTURAL
                                ? <div className="flex justify-center text-blarge">
                                    <EvaluationStatesCircle
                                        status={
                                            typeof related.evaluaciones?.[period] === 'string' && !isNaN(Number(related.evaluaciones[period]))
                                                ? Number(related.evaluaciones[period])
                                                : typeof related.evaluaciones?.[period] === 'number'
                                                    ? related.evaluaciones[period]
                                                    : null
                                        }
                                        size={12}
                                    />
                                </div>
                                : <div className="w-[140px] h-[56px] flex flex-col justify-center items-center">
                                    <EvaluationLaws evaluacion={related.evaluaciones?.[period] !== null ? String(related.evaluaciones?.[period]) : null} />
                                </div>
                        }
                    </div>
                </div>
            ))}
        </section>
    );
}

export default MobileTableRelatedIndicators;